import { takeEvery, put, call } from 'redux-saga/effects'

import axios from 'portal/utils/axios-msal'
import * as actions from './actions'

function* projectConnectionsSummaryLoadSaga(action) {
  if (action.accountId === '' || action.accountId === null) {
    yield put(
      actions.projectConnectionsSummaryLoadFailure('No Account Id was set')
    )
  }
  if (action.projectId === '' || action.projectId === null) {
    yield put(
      actions.projectConnectionsSummaryLoadFailure('No Project Id was set')
    )
  }
  try {
    const response = yield call(
      axios.get,
      '/accounts/' +
        action.accountId +
        '/projects/' +
        action.projectId +
        '/connections-summary'
    )
    const data = response.data
    yield put(actions.projectConnectionsSummaryLoaded(data))
  } catch (error) {
    yield put(actions.projectConnectionsSummaryLoadFailure(error))
  }
}

export function* watch() {
  yield takeEvery(
    actions.PROJ_CONN_SUMMARY_LOAD_SAGA,
    projectConnectionsSummaryLoadSaga
  )
}
